(function () {
  var open = document.querySelector("[data-menu-open]");
  var menu = document.querySelector("[data-menu]");
  var close = document.querySelector("[data-menu-close]");
  if (open && menu) {
    var setOpen = function (on) {
      menu.hidden = !on;
      open.setAttribute("aria-expanded", on ? "true" : "false");
      document.body.style.overflow = on ? "hidden" : "";
    };
    open.addEventListener("click", function () { setOpen(true); });
    if (close) close.addEventListener("click", function () { setOpen(false); });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") setOpen(false);
    });
  }

  document.querySelectorAll("[data-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    wrap.querySelectorAll("button").forEach(function (button) {
      button.addEventListener("click", function () {
        var step = Number(button.getAttribute("data-step"));
        var next = Math.max(0, Number(input.value || 0) + step);
        input.value = String(next);
        var form = wrap.closest("form");
        if (form) form.submit();
      });
    });
  });

  document.querySelectorAll("[data-variant]").forEach(function (input) {
    input.addEventListener("change", function () {
      var id = document.querySelector("[data-variant-id]");
      if (id) id.value = input.value;
      document.querySelectorAll("[data-size]").forEach(function (row) {
        row.classList.toggle("is-on", row.contains(input));
      });
    });
  });
})();
